module.exports = __webpack_public_path__ + "img/ttshop_dpj.cfa0d3e2.svg";